import * as localizationKeys from '../../../consts/localization/localizationKeys';
import connectivityService from '../../../services/device/connectivityService';
import deviceTypesService from '../../../services/device/deviceTypesService';
import {getLocalizedStrings} from '../../../services/localization/localizationService';

const pairingGuideErrorsContent = (deviceType) => {
    const localizedStrings = getLocalizedStrings();
    const isBle = connectivityService.isBle();
    const deviceTypesData = deviceTypesService.getDeviceTypesDataByType(deviceType);
    const deviceName =
        isBle && deviceTypesData?.nameKey
            ? localizedStrings[deviceTypesData.nameKey]
            : localizedStrings[localizationKeys.DEVICE_DEFAULT_NAME];

    return {
        PAIRING_ERRORS: {
            title: localizedStrings[
                isBle ? localizationKeys.BLE_PAIRING_FAIL_GLOBAL_TITLE : localizationKeys.USB_PAIRING_FAIL_GLOBAL_TITLE
            ],
            description:
                localizedStrings[
                    isBle
                        ? localizationKeys.BLE_PAIRING_FAIL_GLOBAL_DESCRIPTION
                        : localizationKeys.USB_PAIRING_FAIL_GLOBAL_DESCRIPTION
                ],
            subDescription: localizedStrings[localizationKeys.PAIR_FAILED_CONTACT_US_LINK_TEXT],
            mainButtonText: localizedStrings[localizationKeys.PAIR_FAIL_TRY_AGAIN_BUTTON],
            secondaryButtonText: localizedStrings[localizationKeys.PAIR_FAIL_SKIP_BUTTON],
            accessibilityTitle:
                localizedStrings[
                    isBle
                        ? localizationKeys.ACCESSIBILITY_FAILED_PAIRING_TITLE
                        : localizationKeys.ACCESSIBILITY_FAILED_CONNECTION_TITLE
                ],
        },
        CONNECTION_ERRORS: {
            title: localizedStrings.formatString(
                localizedStrings[localizationKeys.PAIRING_FAIL_NOT_FOUND_TITLE],
                deviceName
            ),
            description:
                localizedStrings[
                    isBle
                        ? localizationKeys.BLE_PAIRING_FAIL_NOT_FOUND_DESCRIPTION
                        : localizationKeys.USB_PAIRING_FAIL_NOT_FOUND_DESCRIPTION
                ],
            subDescription: localizedStrings[localizationKeys.PAIR_FAILED_CONTACT_US_LINK_TEXT],
            mainButtonText: localizedStrings[localizationKeys.PAIR_FAIL_TRY_AGAIN_BUTTON],
            secondaryButtonText: localizedStrings[localizationKeys.PAIR_FAIL_SKIP_BUTTON],
            accessibilityTitle:
                localizedStrings[
                    isBle
                        ? localizationKeys.ACCESSIBILITY_FAILED_PAIRING_TITLE
                        : localizationKeys.ACCESSIBILITY_FAILED_CONNECTION_TITLE
                ],
        },
        DEVICE_SUPPORT_FAILED_ERRORS: {
            title: localizedStrings[localizationKeys.PAIRING_FAIL_NOT_SUPPORTED_TITLE],
            description: localizedStrings[localizationKeys.PAIRING_FAIL_NOT_SUPPORTED_DESCRIPTION],
            mainButtonText: localizedStrings[localizationKeys.PAIRING_UNABLE_DEVICE_NOT_SUPPORTED_TRY_AGAIN_BUTTON],
            secondaryButtonText: localizedStrings[localizationKeys.PAIRING_UNABLE_DEVICE_NOT_SUPPORTED_SKIP_BUTTON],
            accessibilityTitle: localizedStrings[localizationKeys.ACCESSIBILITY_UNSUPPORTED_DEVICE_ERROR_TITLE],
        },
        WRONG_DEVICE_ERRORS: {
            title: localizedStrings[
                isBle
                    ? localizationKeys.BLE_PAIRING_FAIL_WRONG_DEVICE_TITLE
                    : localizationKeys.USB_PAIRING_FAIL_WRONG_DEVICE_TITLE
            ],
            description:
                localizedStrings[
                    isBle
                        ? localizationKeys.BLE_PAIRING_FAIL_WRONG_DEVICE_DESCRIPTION
                        : localizationKeys.USB_PAIRING_FAIL_WRONG_DEVICE_DESCRIPTION
                ],
            mainButtonText: localizedStrings[localizationKeys.PAIRING_UNABLE_DEVICE_NOT_SUPPORTED_TRY_AGAIN_BUTTON],
            secondaryButtonText: localizedStrings[localizationKeys.PAIRING_UNABLE_DEVICE_NOT_SUPPORTED_SKIP_BUTTON],
            accessibilityTitle: localizedStrings[localizationKeys.ACCESSIBILITY_WRONG_DEVICE_ERROR_TITLE],
        },
    };
};

export {pairingGuideErrorsContent};
